import type { ClassValue } from "clsx";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

import { PaymentStatus } from "@repos/fillout_payment-dtos";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export const formatNumber = (str: number) => {
	return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
export type WithNullableFields<T> = {
	[K in keyof T]: T[K] | undefined;
};

export const translateStatus = (status: string) => {
	switch (status) {
		case PaymentStatus.PENDING:
			return "En attente";
		case PaymentStatus.SUCCESS:
			return "Payé";
		case PaymentStatus.FAILED:
			return "Echoué";
	}
};
